export default __webpack_public_path__ + "media/images/portfolio/gallery-01-480x290-bc9f4ade0f209ea043c31ad7da2d2154.jpg";